// Report grid layout component

import { SimpleGrid } from '@chakra-ui/react';
import { ReportCard } from './ReportCard';
import { Report } from '@/lib/sdk/reports/types';

interface ReportGridProps {
  reports: Report[];
  onViewReport: (report: Report) => void;
  onShareReport: (report: Report) => void;
  onEditReport?: (report: Report) => void;
  onDeleteReport?: (report: Report) => void;
  canShare?: boolean;
  isSuperAdmin?: boolean;
}

/**
 * Grid layout for report cards
 */
export function ReportGrid({
  reports,
  onViewReport,
  onShareReport,
  onEditReport,
  onDeleteReport,
  canShare,
  isSuperAdmin,
}: ReportGridProps) {
  return (
    <SimpleGrid
      columns={{ base: 1, md: 2, lg: 3 }}
      spacing={6}
      w="full"
    >
      {reports.map((report) => (
        <ReportCard
          key={report.id}
          report={report}
          onView={onViewReport}
          onShare={onShareReport}
          onEdit={onEditReport}
          onDelete={onDeleteReport}
          canShare={canShare}
          isSuperAdmin={isSuperAdmin}
        />
      ))}
    </SimpleGrid>
  );
}
